import React, { FC } from 'react';
import { Trans, useTranslation } from 'react-i18next';

// Exigence « EU user consent policy » de Google : la bannière et la modale doivent renvoyer
// vers les règles de confidentialité pour les entreprises. Le lien est le composant <0> de la clé.
const GOOGLE_PRIVACY_URL = 'https://business.safety.google/privacy/';

const GooglePrivacyLink: FC = () => {
  const { t } = useTranslation();

  return (
    <p className="CookieConsentGooglePrivacy">
      <Trans
        t={t}
        i18nKey="cookies-consent-googlePrivacyText"
        components={[
          // Le contenu du lien est injecté par <Trans> depuis la traduction (balise <0>).
          // eslint-disable-next-line jsx-a11y/anchor-has-content
          <a key="googlePrivacy" href={GOOGLE_PRIVACY_URL} target="_blank" rel="noopener noreferrer" />,
        ]}
      />
    </p>
  );
};

export default GooglePrivacyLink;
